export class ExtraFormController {
    $onInit() {
        let fields = [];
        angular.forEach(Object.entries(this.extra || {}), function(field){
            let [fieldName, fieldDetails] = field;
            fields.push({
                'name': fieldName,
                'label': fieldDetails.label
            });
        });
        this.fields = fields;
    }
}

export default ExtraFormController;



// WEBPACK FOOTER //
// ./app/jangl/extra-fields/controller.js